/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { html, nothing } from 'lit';
import service from '@mfe/service';
import { TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION } from '@mfe/service/tracker';
import store from '@mfe/store';
import { save, cancelPage } from '@mfe/store/consents';
import { ConsentGroup } from '@mfe/types/common';
import type Tefcoms from '../../tef-coms';

export const cancelButton = html`
<button
  class="button button-border"
  @click=${
  /* eslint-disable indent */
  () => {
    store.dispatch(cancelPage());
    service.tracker.doTracking(
      TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION,
      {},
    );
  }
}
> Abbrechen
</button>`;

export const saveButton = (changesMadePage: boolean) => html`
<button
    class="button button-default"
    .disabled=${!changesMadePage}
    @click=${
  () => {
    store.dispatch(save());
  }
  /* eslint-enable indent */
}
> Speichern
</button>`;

export const consentGroupTemplate = (consentGroup: ConsentGroup, idx: number, tefComs: Tefcoms) => {
  const divider = html`<hr class="divider" />`;

  return html`
      <div class="section">
          <tef-coms-consent-group
              .consentGroup=${consentGroup}
              .groupIndex=${idx}
              .mode=${tefComs.mode}
          >
          </tef-coms-consent-group>
      </div>
      ${idx < (tefComs.consentGroups as ConsentGroup[]).length - 1 ? divider : null}
  `;
};

export const buttonModeTemplate = (buttonModeButton: string, changesMadePage: boolean) => html`
    <div class="section section-buttons">
      <div class="form-row form-row--buttons">
        ${!buttonModeButton ? cancelButton : nothing}
        ${!buttonModeButton || buttonModeButton === 'save'
    ? saveButton(changesMadePage)
    : nothing}
      </div>
    </div>
  `;
